export const PANEL_WIDTH = 232;
export const PANEL_RIGHT_OFFSET = 12;
export const SOURCES_OUTPUTS_RESERVED_WIDTH = 252;

const MIN_CHAT_WIDTH = 360;

// Give Sources its own column so messages and the composer are centered in
// the space between navigation and Sources at every width. Hide the card
// when an artifact is open (chat should use the leftover column) or when
// both columns can no longer fit at a readable width.
export function resolveSourcesOutputsLayout({ chatPaneWidth, artifactOpen, minChatWidth = MIN_CHAT_WIDTH } = {}) {
  if (artifactOpen
    || !Number.isFinite(chatPaneWidth)
    || chatPaneWidth < minChatWidth + SOURCES_OUTPUTS_RESERVED_WIDTH) {
    return { canShowPanel: false, reservedRight: 0 };
  }

  return { canShowPanel: true, reservedRight: SOURCES_OUTPUTS_RESERVED_WIDTH };
}

export function resolveSourcesOutputsReservedRight({ showSourcesOutputsPanel, showBrowserPanel, reservedRight } = {}) {
  if (!showSourcesOutputsPanel || showBrowserPanel) return 0;
  return Number.isFinite(reservedRight) ? reservedRight : 0;
}
